import React from 'react'
import { Form, Button } from 'react-bootstrap'
import Layout from './Layout'
import { desktopAssets, fixedAssets } from 'src/containers/PreCache'
import RegisterForm from './RegisterForm'
import { Link } from 'react-router-dom'

export default function RegisterDesktop() {
  return (
    <Layout>
      <div className="wrap relative">
        <div className="p-4 mb-4">
          <Link to="/">
            <img src={desktopAssets.headerLogo} alt="Background" className="header-logo" />
          </Link>
        </div>
        <div className="content-wrapper">
          <RegisterForm />
          {/* <p className='closedText'>Registration is now closed.</p>
          <p className='closedText'>Thank you for your interest and participation!</p> */}
        </div>
      </div>
    </Layout>
  )
}
